var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-dv-data sc-dv-data-section"},[(_vm.title)?_c('div',{staticClass:"title",attrs:{"title":_vm.title}},[_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }